import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import LoginPage from "./pages/LoginPage";
import DashboardLayout from "./components/DashboardLayout";
import Profile from "./pages/Profile";
import PunchIn from "./pages/PunchIn";
import PunchOut from "./pages/PunchOut";
import Attendance from "./pages/Attendance";
import AttendanceRegularizationList from "./pages/AttendanceRegularization";
import Report from "./pages/Report";
import Leave from "./pages/Leave";
import Query from "./pages/Query";
import { Toaster } from "react-hot-toast";


import { AttendanceProvider } from "./context/AttendanceContext"; // agar ye needed hai to rakho
import { AuthProvider } from "./context/AuthContext";
import Dashboard from "./pages/Dashboard";
import LeaveCard from "./pages/LeaveCard";
import Jobs from "./pages/Jobs";


// ✅ Protected Route
function ProtectedRoute({ children }) {
  const { isLoggedIn } = useSelector((state) => state.auth);

  return isLoggedIn ? children : <Navigate to="/login" replace />;
}

// ✅ Public Route
function PublicRoute({ children }) {
  const { isLoggedIn } = useSelector((state) => state.auth);

  return isLoggedIn
    ? <Navigate to="/dashboard/dashboard" replace />
    : children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" reverseOrder={false} />
      <AuthProvider>
        <AttendanceProvider>
          <Routes>
          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="profile" replace />} />
            <Route path="profile" element={<Profile />} />
            <Route path="punch-in" element={<PunchIn />} />
            <Route path="punch-out" element={<PunchOut />} />
            <Route path="jobs" element={<Jobs />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="leave" element={<Leave />} />
            <Route path="leave-card" element={<LeaveCard />} />
            <Route path="query" element={<Query />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="Regularization" element={<AttendanceRegularizationList />} />
            <Route path="report" element={<Report />} />

          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AttendanceProvider>
    </AuthProvider>
    </BrowserRouter>
  );
}